module.exports = __webpack_public_path__ + "static/media/backgroundBoard.840f88ac.png";